<script lang="ts">
    import {getInjector} from 'src/core';
    import type {RecordSearchParams, Sorting} from 'src/typings';
    import type {FondFieldTypeDefinitions} from 'src/features/record/field-types/types';
    import type {FilterValuesMap, KpSearchFieldTypeFiltersOptions} from './types';
    import type {RecordRow} from 'src/features/record-grid/lib/types';
    import {onMount} from 'svelte';
    import {createSearchFieldTypeFiltersContext} from './search-field-type-filters.context';
    import {exists} from 'shared/utils/custom-utils';
    import {FieldTypeDataService} from 'src/features/record/field-types/field-type-data.service';
    import {getSearchContext} from 'src/features/search/kp-search-context/search-context';
    import {createFilterQtString} from './create-filter-qt-string';
    import {isEqual} from 'lodash-es';

    export let fondId: number;
    export let fieldTypeDefinitions: FondFieldTypeDefinitions | null = null;
    export let options: KpSearchFieldTypeFiltersOptions = {};

    const context = createSearchFieldTypeFiltersContext(options.defaultFilterValues ?? {}, options.forcedFilterValues ?? {}, options.activeSorting ?? null);
    const fieldTypeDataService = getInjector().getByClass(FieldTypeDataService);
    const searchContext = getSearchContext<RecordRow, RecordSearchParams>();

    export let anyFiltersActive = false; // For binding from parent

    const filteredValues$ = context.filteredValues$;
    const activeSorting$ = context.activeSorting$;
    $: updateSearch($filteredValues$, $activeSorting$);

    function updateSearch(filteredValues: FilterValuesMap, sorting: Sorting | null) {
        const newQtString = createFilterQtString({
            filteredValues,
            forcedValues: context.forcedFilterValues
        });
        anyFiltersActive = exists(newQtString) && Object.keys(filteredValues).length > 0;

        const currentQtString = searchContext.getFrontendParams().qt ?? null;
        const currentSorting = searchContext.getFrontendParams().sorting ?? null;

        if (isEqual(newQtString, currentQtString) && isEqual(sorting, currentSorting)) {
            return;
        }

        searchContext.newSearchWithPartialParams({
            qt: newQtString,
            sorting
        });
    }

    onMount(async () => {
        if (exists(fieldTypeDefinitions)) {
            context.setFieldTypeDefinitions(fieldTypeDefinitions);
            return;
        }

        const fondFieldTypeDefinitions = await fieldTypeDataService.loadFondFieldTypeDefinitions(fondId);
        context.setFieldTypeDefinitions(fondFieldTypeDefinitions);
    });
</script>

<slot/>